var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('svg-icon',{directives:[{name:"clickLock",rawName:"v-clickLock",value:(_vm.click),expression:"click"}],attrs:{"icon-class":_vm.isFullscreen ? 'exit-fullscreen' : 'onfullscreen'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }